<template>
  <div class="user-info-container">
    <el-card>
      <el-descriptions 
        title="用户信息" 
        direction="vertical" 
        :column="4" 
        border
        v-if="userInfo"
      >
        <el-descriptions-item label="用户名">{{ userInfo.userName }}</el-descriptions-item>
        <el-descriptions-item label="角色">{{ userInfo.role }}</el-descriptions-item>
        <el-descriptions-item label="场地">{{ userInfo.ground }}</el-descriptions-item>
        <el-descriptions-item label="昵称">{{ userInfo.nickName }}</el-descriptions-item>
      </el-descriptions>
      
      <el-empty 
        v-else-if="!loading" 
        description="暂无用户信息"
      ></el-empty>
      
      <el-loading 
        v-if="loading" 
        text="加载用户信息中..." 
        fullscreen
      ></el-loading>

      <!-- 登录/退出按钮 -->
      <div class="button-container">
        <el-button 
          v-if="hasToken" 
          type="danger" 
          @click="handleLogout"
          :loading="isLogoutLoading"
        >
          退出登录
        </el-button>
        <el-button 
          v-else 
          type="primary" 
          @click="handleLogin"
        >
          登录
        </el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import adminrequest from '@/utils/adminrequest'

export default {
  name: 'UserInfo',
  data() {
    return {
      userInfo: null,
      loading: false,
      isLogoutLoading: false // 退出登录加载状态
    };
  },
  computed: {
    // 判断是否存在token
    hasToken() {
      return !!localStorage.getItem('token');
    }
  },
  mounted() {
    if (this.hasToken) {
      this.getUserInfo();
    }
  },
  methods: {
    async getUserInfo() {
      this.loading = true;
      try {
        const options = {
          method: 'GET',
          url: '/admin/user/getUserInfo',
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          }
        };
        
        const response = await adminrequest.request(options);
        
        if (response.data.code === 200 && response.data.data) {
          this.userInfo = response.data.data;
          console.log('用户信息加载成功');
          return Promise.resolve();
        } else {
          console.error('获取用户信息失败:', response.data.message);
          this.$message.error('获取用户信息失败');
          return Promise.reject();
        }
      } catch (error) {
        console.error('获取用户信息异常:', error);
        this.$message.error('获取用户信息异常，请重试');
        return Promise.reject();
      } finally {
        this.loading = false;
      }
    },
    // 处理登录跳转
    handleLogin() {
      this.$router.push('/login');
    },
    // 处理退出登录（包含后端请求）
    async handleLogout() {
      this.$confirm('确定要退出登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
		const token = localStorage.getItem('token');
        if (!token) {
          this.$router.push('/login');
          return;
        }
		
        this.isLogoutLoading = true;
        try {
          // 发送退出登录请求到后端
          const options = {
            method: 'POST',
            url: '/admin/user/logout',
            headers: {
              'Content-Type': 'application/json;charset=utf-8'
            }
          };

          const response = await adminrequest.request(options);
          console.log('退出登录响应:', response.data);

          // 处理后端响应
          if (response.data.code === 200) {
            this.$message.success('退出登录成功');
          } else {
            this.$message.success('退出登录成功');
          }
		  
          // 清除本地token和用户信息
          localStorage.removeItem('token');
          this.userInfo = null;
          this.$router.push('/login');
        } catch (error) {
          console.error('退出登录请求失败:', error);
          // 即使请求失败也清除本地状态
          localStorage.removeItem('token');
          this.userInfo = null;
          this.$message.success('退出登录成功');
          this.$router.push('/login');
        } finally {
          this.isLogoutLoading = false;
        }
      }).catch(() => {
        this.$message.info('已取消退出');
      });
    }
  }
};
</script>

<style scoped>
.user-info-container {
  padding: 20px;
}

::v-deep .el-card {
  max-width: 800px;
  margin: 0 auto;
  padding-bottom: 20px;
}

::v-deep .el-descriptions {
  margin-top: 10px;
  margin-bottom: 20px;
}

::v-deep .el-descriptions__label {
  font-weight: bold;
}

.button-container {
  text-align: center;
  margin-top: 20px;
}
</style>
